import { Attachment } from '@/types/Attachment'

import { BookablePersonType } from './BookablePersonType'

export interface ActivityFeed {
  activityId: number
  activityType: ActivityType | string
  agentName?: string
  attachments?: Attachment[]
  childComments?: Comment[]
  content: string
  datetime: string
  destinationParty: string
  direction: Direction
  displayCity?: string
  entityId: number
  entityType: BookablePersonType
  externalId: string
  externalSource: string
  home?: string
  homeId?: number
  originatingParty: string
  reservationId?: number
}

export enum Direction {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}

export enum ActivityType {
  CALL = 'Call',
  COMMENT = 'Comment',
  EMAIL = 'Email',
  PUSH_NOTIFICATION = 'Push Notification',
  SMS = 'SMS',
}
